import React, { useState } from 'react';
import { ConfirmationModal } from '@/shared/components/modals';
import { cancelTempRequest } from '../api';

interface TempRequestActionsProps {
  temp_request_id: number;
  authenticity_token: string;
  dashboard_url: string;
  // False once the shift has ended; the API rejects cancelling a past shift.
  can_cancel?: boolean;
}

export const TempRequestActions: React.FC<TempRequestActionsProps> = ({
  temp_request_id,
  authenticity_token,
  dashboard_url,
  can_cancel = true
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleCancelClick = () => {
    setShowCancelModal(true);
    setErrorMessage(null);
  };

  const handleConfirmCancel = async () => {
    setIsCancelling(true);
    setErrorMessage(null);

    try {
      const token = authenticity_token || (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content;
      const res = await cancelTempRequest(temp_request_id, token);

      if (res.ok) {
        // Reload page to show cancellation confirmation
        window.location.reload();
      } else {
        setErrorMessage(res.body?.error || 'Failed to cancel temp booking. Please try again or contact the practice directly.');
        setIsCancelling(false);
      }
    } catch (error) {
      setErrorMessage('An error occurred. Please try again or contact the practice directly.');
      setIsCancelling(false);
    }
  };

  return (
    <>
      <div className="d-grid gap-2 d-md-flex justify-content-md-center">
        {can_cancel && (
          <button
            className="btn btn-danger btn-lg px-4"
            onClick={handleCancelClick}
          >
            <i className="fa fa-times-circle me-2"></i>Cancel Temp Booking
          </button>
        )}
        <a href={dashboard_url} className="btn btn-primary btn-lg px-4">
          <i className="fa fa-dashboard me-2"></i>Return to Dashboard
        </a>
      </div>

      <ConfirmationModal
        show={showCancelModal}
        onHide={() => {
          if (!isCancelling) {
            setShowCancelModal(false);
            setErrorMessage(null);
          }
        }}
        title="Cancel Temp Booking"
        message={
          errorMessage ||
          "Are you sure you want to cancel this temp booking? The practice will be notified immediately. This action cannot be undone."
        }
        confirmText="Yes, Cancel Booking"
        cancelText="No, Keep Booking"
        confirmVariant="danger"
        onConfirm={handleConfirmCancel}
        loading={isCancelling}
        size="lg"
      />
    </>
  );
};

export default TempRequestActions;
